import Head from "next/head"
import { Component, type ReactNode } from "react"
import { twMerge } from "tailwind-merge"
import MarketingHeading from "./common/MarketingHeading"

export class AppErrorBoundary extends Component<{ children: ReactNode }> {
  state = {
    hasError: false,
    errorMsg: "",
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, erroMsg: error?.toString() ?? "" }
  }

  // componentDidCatch(error, errorInfo) {
  // we can pipe this to sentry or other logger if we want
  // }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <Head>
            <title>Token Terminal | Fundamentals for crypto</title>
            <link rel="shortcut icon" href="/favicon.ico" />
          </Head>
          <div className="flex flex-col gap-2 items-center justify-center h-screen">
            <MarketingHeading level={1} className={twMerge("text-fg-error")}>
              Error
            </MarketingHeading>
            <div className="text-sm text-fg-secondary">{this.state.errorMsg}</div>
          </div>
        </>
      )
    }

    return this.props.children
  }
}
